
<!-- Without spinner -->
<div class="confirm-popup-without-spinner">
    <owc-modal-dialog #modalDialogElement disable-backdrop-click [visible]="true">
        <div class="modal-content">
            <owc-typography class="heading">
                {{data.HEADER}} 
            </owc-typography>
            <owc-typography class="desc" *ngFor="let para of data.DESC; let i = index">
                <span *ngIf="!formView"> {{ para }} </span>
            </owc-typography>
            <owc-typography class="reason-desc" *ngIf="formView">
                {{data.REASON_DESC}}
            </owc-typography>
            <form [formGroup]="reasonForm" *ngIf="formView">
                <div>
                    <owc-input [type]="'textarea'" class="clswidth owc-input-width input-margin-top"
                        [variant]="'outlined'" label="Enter reason" formControlName="reason"
                        [maxlength]="200" [appFormControlValidationMsg]="{
                            default: '',
                            required: i18n.STUDY.STEP_1.ERRORMSG.REQUIRED_FIELD
                          }">
                    </owc-input>
                </div>
            </form>
        </div>
        <owc-component-footer slot="footer" *ngIf="!formView">
            <div slot="suffix" class="modal-footer">
            <owc-button data-testid="confirmation-no-spinner-decline-btn"
                (click)=" onDecline()" [variant]="'secondary'">
                {{data.CANCEL_BTN}}
            </owc-button>
            <owc-button data-testid="confirmation-no-spinner-accept-btn"
                (click)="onAccept()" class="margin-left-16">
                {{ data.CONFIRM_BTN}}
            </owc-button>
            </div>
        </owc-component-footer>
        <owc-component-footer slot="footer" *ngIf="formView">
            <div slot="suffix" class="modal-footer">
            <owc-button data-testid="confirmation-no-spinner-reason-decline-btn"
                (click)="onReasonDecline()" [variant]="'secondary'">
                {{data.CANCEL_REASON}}
            </owc-button>
            <owc-button data-testid="confirmation-no-spinner-reason-accept-btn"
                (click)="onAcceptReason()" class="margin-left-16">
                {{ data.CANCEL_SUBMIT}}
            </owc-button>
            </div>
        </owc-component-footer>
    </owc-modal-dialog>
</div>


